var Handlebars = require("../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.css : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.zones : depth0),{"name":"each","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "        <style class=\"user-defined style-display-"
    + ((stack1 = alias1((depth0 != null ? depth0.id : depth0), depth0)) != null ? stack1 : "")
    + "\">\n            "
    + ((stack1 = alias1((depth0 != null ? depth0.css : depth0), depth0)) != null ? stack1 : "")
    + "\n        </style>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.css : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "            <style class=\"user-defined style-zone-"
    + ((stack1 = alias1((depth0 != null ? depth0.id : depth0), depth0)) != null ? stack1 : "")
    + "\">\n                "
    + ((stack1 = alias1((depth0 != null ? depth0.css : depth0), depth0)) != null ? stack1 : "")
    + "\n            </style>\n";
},"7":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "    <style>\n    #display_"
    + ((stack1 = alias1((depth0 != null ? depth0.id : depth0), depth0)) != null ? stack1 : "")
    + " {\n        width: "
    + ((stack1 = alias1((depth0 != null ? depth0.width : depth0), depth0)) != null ? stack1 : "")
    + "px;\n        height: "
    + ((stack1 = alias1((depth0 != null ? depth0.height : depth0), depth0)) != null ? stack1 : "")
    + "px;\n    }\n\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.zones : depth0),{"name":"each","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</style>\n    <div id=\"display_"
    + ((stack1 = alias1((depth0 != null ? depth0.id : depth0), depth0)) != null ? stack1 : "")
    + "\" class=\"display "
    + this.escapeExpression(__default(require("../Utility/Handlebars/precompile.helpers/ternary.ts")).call(depth0,(depth0 != null ? depth0.isPaused : depth0),"hide_display","",{"name":"ternary","hash":{},"data":data}))
    + "\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.zones : depth0),{"name":"each","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "    #zone_"
    + ((stack1 = alias1((depth0 != null ? depth0.id : depth0), depth0)) != null ? stack1 : "")
    + " {\n        width: "
    + ((stack1 = alias1((depth0 != null ? depth0.width : depth0), depth0)) != null ? stack1 : "")
    + "px;\n        height: "
    + ((stack1 = alias1((depth0 != null ? depth0.height : depth0), depth0)) != null ? stack1 : "")
    + "px;\n        z-index: "
    + ((stack1 = alias1((depth0 != null ? depth0.z : depth0), depth0)) != null ? stack1 : "")
    + ";\n        left: "
    + ((stack1 = alias1((depth0 != null ? depth0.x : depth0), depth0)) != null ? stack1 : "")
    + "px;\n        top: "
    + ((stack1 = alias1((depth0 != null ? depth0.y : depth0), depth0)) != null ? stack1 : "")
    + "px;\n\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.backgroundColor : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    }\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1;

  return "        background-color: "
    + ((stack1 = this.lambda((depth0 != null ? depth0.backgroundColor : depth0), depth0)) != null ? stack1 : "")
    + ";\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.defaultImg : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.program(14, data, 0),"data":data})) != null ? stack1 : "");
},"12":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "                <div\n                    id=\"zone_"
    + ((stack1 = alias1((depth0 != null ? depth0.id : depth0), depth0)) != null ? stack1 : "")
    + "\"\n                    class=\"zone zone-"
    + ((stack1 = alias1((depth0 != null ? depth0.id : depth0), depth0)) != null ? stack1 : "")
    + "\"\n                    data-background-image=\""
    + ((stack1 = alias1((depth0 != null ? depth0.defaultImg : depth0), depth0)) != null ? stack1 : "")
    + "\"\n                >\n                </div>\n";
},"14":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "                <div id=\"zone_"
    + ((stack1 = alias1((depth0 != null ? depth0.id : depth0), depth0)) != null ? stack1 : "")
    + "\" class=\"zone zone-"
    + ((stack1 = alias1((depth0 != null ? depth0.id : depth0), depth0)) != null ? stack1 : "")
    + "\">\n                </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.displays : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.displays : depth0),{"name":"each","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});